// Runtime configuration — the single place the site learns which backend to
// talk to.
//
// The API origin is deliberately NOT baked into the bundle. `public/config.js`
// is loaded by index.html before the app boots and sets `window.__TL_CONFIG__`,
// so one build can serve several hospital groups: each deployment edits its own
// config.js and needs no rebuild.
//
// Which source wins depends on the build:
//   production  — config.js first, then REACT_APP_* as a fallback
//   development — REACT_APP_* first (from .env.development), so `npm start`
//                 keeps talking to http://localhost:8010 and is not hijacked by
//                 the production-shaped '/app-api' sitting in public/config.js
// If neither is set, the value is '' and every request becomes an origin-relative
// path — `${API_BASE_URL}/api/x` resolves to `/api/x` on whichever host served
// the page.

export interface TrustLinkRuntimeConfig {
  /** Backend origin, or an origin-relative prefix such as '/app-api'. */
  API_BASE_URL?: string;
}

declare global {
  interface Window {
    __TL_CONFIG__?: TrustLinkRuntimeConfig;
  }
}

const runtime: TrustLinkRuntimeConfig =
  (typeof window !== 'undefined' && window.__TL_CONFIG__) || {};

const IS_DEV = process.env.NODE_ENV === 'development';

/** Drop trailing slashes so callers can always write `${API_BASE_URL}/api/x`. */
const stripTrailingSlash = (url: string): string => url.replace(/\/+$/, '');

const nonEmpty = (v: string | undefined): string | undefined => {
  const t = (v ?? '').trim();
  return t === '' ? undefined : t;
};

const fromRuntime = nonEmpty(runtime.API_BASE_URL);
const fromEnv = nonEmpty(process.env.REACT_APP_API_BASE_URL);

/** In dev the .env value wins; in a production build config.js wins. */
export const API_BASE_URL = stripTrailingSlash(
  (IS_DEV ? (fromEnv ?? fromRuntime) : (fromRuntime ?? fromEnv)) ?? ''
);

/** Absolute URL for an upload path returned by the API (e.g. 'uploads/x.png'). */
export const mediaUrl = (path: string): string =>
  `${API_BASE_URL}/${String(path).replace(/^\/+/, '')}`;
